import {numberFormat, resetTooltip} from "./Utils.js";
import Data from "./Data.js";

export default class Tutorial
{
    play() {
        if ('running_tutorial' in BS_EVENTS && BS_EVENTS.running_tutorial === true) {
            return;
        }

        BS_EVENTS.running_tutorial = true;
        BS_EVENTS.was_quick_menu_visible = document.getElementById('quick-menu').classList.contains('show');

        if (BS_EVENTS.was_quick_menu_visible) {
            document.getElementById('quick-menu').classList.remove('show');
        }

        this.controller = new AbortController();
        this.signal = this.controller.signal;
        this.activeFrameIndex = 0;
        this.isFirstFrame = true;
        this.isLastFrame = false;

        if (!document.getElementById('tutorial-template')) {
            return;
        }

        const template = document.getElementById('tutorial-template').content;
        this.template = template.firstElementChild.cloneNode(true);

        this.populateDynamicData();

        this.template.addEventListener('keydown', e => {
            if (e.key === 'Escape') {
                this.close();
            }

            if (e.key === 'ArrowRight' && !this.isLastFrame) {
                this.nextFrame();
            }

            if (e.key === 'ArrowLeft' && !this.isFirstFrame) {
                this.previousFrame();
            }
        }, { signal: this.signal });

        this.template.addEventListener('click', e => {
            const target = e.target;

            if (target.matches('.control') && !target.classList.contains('active')) {
                this.switchFrame(target);
            }

            if (target.matches('#tutorial') || (target.closest('#tutorial__header') && target.closest('button'))) {
                this.close();
            }

            if (target.matches('#next_frame') && !target.classList.contains('button--disabled')) {
                this.nextFrame();
            }

            if (target.matches('#previous_frame') && !target.classList.contains('button--disabled')) {
                this.previousFrame();
            }
        });

        document.body.appendChild(this.template);
        this.template.focus();

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                document.body.classList.add('tutorial--opened');
            });
        });

        __All(this.template);

        this.frames = this.template.querySelectorAll('#tutorial__frames .frame');
        this.controls = this.template.querySelectorAll('#tutorial__controls .control');
    }

    switchFrame(selectedFrame)
    {
        const frameKey = [...selectedFrame.classList].find(name => name.startsWith('ctrl__')).replace('ctrl__', '');

        this.frames.forEach(frame => frame.classList.remove('active'));
        this.controls.forEach(ctrl => ctrl.classList.remove('active'));

        selectedFrame.classList.add('active');
        this.template.querySelector('#tutorial__frames #' + frameKey).classList.add('active');

        this.activeFrameIndex = [...this.controls].indexOf(selectedFrame);
        this.isFirstFrame = this.activeFrameIndex === 0;
        this.isLastFrame = this.activeFrameIndex !== -1 && this.activeFrameIndex === this.controls.length - 1;

        this.template.querySelector('#tutorial__frames').scrollTop = 0;

        this.updateButtonState();
    }

    nextFrame() {
        if (!this.isLastFrame) {
            const currentFrame = this.controls[this.activeFrameIndex];
            currentFrame.classList.remove('active');

            const nextFrame = this.controls[this.activeFrameIndex + 1];
            nextFrame.click();
        } else {
            this.close();
        }
    }

    previousFrame() {
        const currentFrame = this.controls[this.activeFrameIndex];
        currentFrame.classList.remove('active');

        const prevFrame = this.controls[this.activeFrameIndex - 1];
        prevFrame.click();
    }

    updateButtonState() {
        this.template.querySelector('button#previous_frame').classList.toggle('button--disabled', this.isFirstFrame);

        this.template.querySelector('button#next_frame').textContent =
            this.isLastFrame ? __('tutorial.cta_ready') :
                this.isFirstFrame ? __('tutorial.cta_lets_get_started') :
                    __('tutorial.cta_next');

        if (this.isLastFrame) {
            this.template.querySelector('button#next_frame').classList.replace('button--primary', 'button--success');
        } else {
            this.template.querySelector('button#next_frame').classList.replace('button--success', 'button--primary');
        }
    }

    populateDynamicData()
    {
        const prices = [120, 40, 35, 40];
        this.template.querySelector('#plan .card__box:nth-child(1) .list span:last-child').textContent = numberFormat(2400);
        this.template.querySelectorAll('#plan .card__box:nth-child(2) .list .item').forEach((item, idx) => {
            item.querySelector('span:last-child').textContent = numberFormat(prices[idx]);
        });

        this.template.querySelector('#start_tracking .amount').textContent = numberFormat(60);
        this.template.querySelector('#start_tracking .progress__under_labels span.text:first-child span:last-child').textContent = numberFormat(60);
        this.template.querySelector('#start_tracking .progress__under_labels span.text:last-child span:last-child').textContent = numberFormat(prices[0]);
    }

    close() {
        const closeTheTutorial = () => {
            delete BS_EVENTS.running_tutorial;

            if (BS_EVENTS.was_quick_menu_visible) {
                document.getElementById('quick-menu').classList.add('show');
            }

            delete BS_EVENTS.was_quick_menu_visible;

            this.controller.abort();
            document.body.classList.remove('template--opened');
            this.template.remove();

            resetTooltip();
        }

        const data = new Data();

        if (typeof RUN_INTRO !== 'undefined' && RUN_INTRO) {
            data.checkedIntro().then(() => {
                window.RUN_INTRO = false;
                closeTheTutorial();
            });
        } else {
            closeTheTutorial();
        }
    }
}